import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ClientsPage from "@/pages/ClientsPage";
import ProcessPage from "@/pages/ProcessPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import DiagnosticPage from "@/pages/DiagnosticPage";
import MonEspacePage from "@/pages/MonEspacePage";
import ProfilPage from "@/pages/ProfilPage";
import LoginPage from "@/pages/LoginPage";
import ConfirmationEmailPage from "@/pages/ConfirmationEmailPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Page de confirmation email - sans navbar/footer */}
          <Route path="/confirmation-email" element={
            <div className="min-h-screen bg-[#0B1F3B] text-white">
              <ConfirmationEmailPage />
              <Toaster position="top-right" richColors />
            </div>
          } />
          
          {/* Routes principales avec navbar/footer */}
          <Route path="/*" element={
            <div className="min-h-screen bg-[#0B1F3B] text-white">
              <Navbar />
              <main>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/clients" element={<ClientsPage />} />
                  <Route path="/processus" element={<ProcessPage />} />
                  <Route path="/a-propos" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/diagnostic" element={<DiagnosticPage />} />
                  <Route path="/mon-espace" element={<MonEspacePage />} />
                  <Route path="/mon-profil" element={<ProfilPage />} />
                  <Route path="/connexion" element={<LoginPage />} />
                </Routes>
              </main>
              <Footer />
              <Toaster position="top-right" richColors />
            </div>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
